module.exports = __webpack_public_path__ + "img/album05_17.86bd6da7.jpg";